/**
 * @voltxampere/ui — 7474 dual D flip-flop TTL variant (Sprint 41-4, placeholder)
 *
 * PLACEHOLDER: drag-drop and schema persistence work, but Sprint 41
 * DC stamp returns `vLow` for `gateFunction: "D-FLOP"` per ADR-0061
 * §"MVP DC-only scope". Full sequential clock-edge simulation (Q
 * tracks D on rising clock edge, set/reset asynchronous) lands in
 * Sprint 42+ once the transient state machine layer ships.
 *
 * Reference: TI SN5474. Engine zero-diff invariant honored —
 * canonical `digital-gate` via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const logic7474 = {
    id: "7474",
    nameTr: "7474 (Çift D Flip-Flop, DIP-14, placeholder)",
    nameEn: "7474 (Dual D Flip-Flop, DIP-14, placeholder)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "7474",
    schemaType: "digital-gate",
    defaultParams: {
        gateFunction: "D-FLOP",
        vHigh: 2.4,
        vLow: 0.4,
        threshold: 1.4,
        propagationDelay: 25e-9,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=logic-7474.js.map